// extracted by mini-css-extract-plugin
module.exports = {"overlay":"overlay___215y8","dialogContainer":"dialogContainer___2CKWl","dialogContent":"dialogContent___1126S","back":"back___3ZCI9","icon20":"icon20___3_T5E"};